export const resourceTitle = "Cadastro de depósito";
export const resourceSingularName = "Depósito";
export const resourcePluralName = "Depósitos";
// @todo: review endpoint
export const resourceKey = "endereco/deposito";

export const idKey = "id";

export const headers = [
  { label: "Status", key: "status", isVisible: true },
  { label: "Código", key: "codigo", isVisible: true },
  { label: "Placa", key: "placa", isVisible: true },
  { label: "Motorista", key: "motorista", isVisible: true },
  { label: "Transportadora", key: "transportadora", isVisible: true },
  { label: "Movimento", key: "movimento", isVisible: true },
  { label: "Data Entrada", key: "dataEntrada", isVisible: true },
];

export const mockData = [
  {
    // Corresponds to "Chegada Confirmada" in the image
    status: "Chegada Confirmada", 
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Corresponds to "Liberado Docas" in the image
    status: "Liberado Docas", 
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Corresponds to "Entrada Confirmada" in the image
    status: "Entrada Confirmada", 
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Another "Chegada Confirmada"
    status: "Chegada Confirmada",
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Another "Entrada Confirmada"
    status: "Entrada Confirmada",
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Yet another "Entrada Confirmada"
    status: "Entrada Confirmada",
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Another "Liberado Docas"
    status: "Liberado Docas",
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  // You can add more mock data as needed, varying the status to test all conditions
  {
    status: "Urgente", // Example using a status from your renderStatus logic
    codigo: "48305",
    placa: "ABC1234",
    motorista: "Maria Silva",
    transportadora: "Rápido Ltda",
    movimento: "Recebimento",
    dataEntrada: "19/04/2025",
  },
  {
    status: "Livre", // Example using 'Livre' status
    codigo: "48306",
    placa: "XYZ7890",
    motorista: "João Souza",
    transportadora: "Transporte Feliz",
    movimento: "Saída",
    dataEntrada: "20/04/2025",
  },
  {
    status: "Ocupado", // Example using 'Ocupado' status
    codigo: "48307",
    placa: "GHI5678",
    motorista: "Ana Paula",
    transportadora: "Entrega Certa",
    movimento: "Descarregamento",
    dataEntrada: "21/04/2025",
  },
   {
    // Corresponds to "Chegada Confirmada" in the image
    status: "Chegada Confirmada", 
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Corresponds to "Liberado Docas" in the image
    status: "Liberado Docas", 
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Corresponds to "Entrada Confirmada" in the image
    status: "Entrada Confirmada", 
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Another "Chegada Confirmada"
    status: "Chegada Confirmada",
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Another "Entrada Confirmada"
    status: "Entrada Confirmada",
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Yet another "Entrada Confirmada"
    status: "Entrada Confirmada",
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  {
    // Another "Liberado Docas"
    status: "Liberado Docas",
    codigo: "48304",
    placa: "NKD4797",
    motorista: "Francisco Reinaldo Evangelista Araújo",
    transportadora: "Monte Sereno",
    movimento: "Expedição",
    dataEntrada: "18/04/2025",
  },
  // You can add more mock data as needed, varying the status to test all conditions
  {
    status: "Urgente", // Example using a status from your renderStatus logic
    codigo: "48305",
    placa: "ABC1234",
    motorista: "Maria Silva",
    transportadora: "Rápido Ltda",
    movimento: "Recebimento",
    dataEntrada: "19/04/2025",
  },
  {
    status: "Livre", // Example using 'Livre' status
    codigo: "48306",
    placa: "XYZ7890",
    motorista: "João Souza",
    transportadora: "Transporte Feliz",
    movimento: "Saída",
    dataEntrada: "20/04/2025",
  },
  {
    status: "Ocupado", // Example using 'Ocupado' status
    codigo: "48307",
    placa: "GHI5678",
    motorista: "Ana Paula",
    transportadora: "Entrega Certa",
    movimento: "Descarregamento",
    dataEntrada: "21/04/2025",
  },
    {
    status: "Livre", // Example using 'Livre' status
    codigo: "48306",
    placa: "XYZ7890",
    motorista: "João Souza",
    transportadora: "Transporte Feliz",
    movimento: "Saída",
    dataEntrada: "20/04/2025",
  },
  {
    status: "Ocupado", // Example using 'Ocupado' status
    codigo: "48307",
    placa: "GHI5678",
    motorista: "Ana Paula",
    transportadora: "Entrega Certa",
    movimento: "Descarregamento",
    dataEntrada: "21/04/2025",
  },  {
    status: "Livre", // Example using 'Livre' status
    codigo: "48306",
    placa: "XYZ7890",
    motorista: "João Souza",
    transportadora: "Transporte Feliz",
    movimento: "Saída",
    dataEntrada: "20/04/2025",
  },
  {
    status: "Ocupado", // Example using 'Ocupado' status
    codigo: "48307",
    placa: "GHI5678",
    motorista: "Ana Paula",
    transportadora: "Entrega Certa",
    movimento: "Descarregamento",
    dataEntrada: "21/04/2025",
  }

];

 